export const templateComps = {
  confirmModal: {
    cancel: "Anuluj",
    delete: "Usuń",
  },
  channexIncident: {
    kicker: "Ważny komunikat",
    brandTitle: "Awaria zewnętrzna",
    closeLabel: "Zamknij komunikat",
    subtitle:
      "Monitorujemy sytuację i sprawdzimy synchronizację, gdy tylko usługa zostanie przywrócona.",
    title:
      "Ogólna awaria połączenia z Booking / Airbnb / zewnętrznym channel manager",
    lead: "Dzień dobry, wykrywamy ogólną awarię u naszego zewnętrznego dostawcy synchronizacji z OTA.",
    text: "Awaria dotyczy jego API i może opóźnić synchronizację rezerwacji, dostępności oraz blokad terminów.",
    note: "Gdy tylko połączenie wróci, sprawdzimy synchronizację danych, aby zweryfikować rezerwacje, dostępność i blokady terminów.",
    textLast:
      "W WA Checkin sprawdzimy synchronizację, gdy usługa znów będzie działać.",
    button: "Rozumiem",
  },
  notificationsNav: {
    title: "Powiadomienia",
    recent: "ostatnie",
    emptyTitle: "Brak powiadomień",
    emptyText:
      "Gdy wydarzy się coś ważnego w rezerwacjach, pojawi się to tutaj.",
    seeAll: "Zobacz wszystkie powiadomienia",
    meta: {
      t1: { status: "Nowa", category: "rezerwacja" },
      t2: { status: "Zaktualizowana", category: "rezerwacja" },
      t3: { status: "Anulowana", category: "rezerwacja" },
      t4: { status: "Zakończony", category: "check-in" },
      t5: { status: "Zamówiona", category: "usługa" },
      t6: { status: "Otrzymana", category: "prośba" },
      t7: { status: "Zatwierdzona", category: "prośba" },
      t8: { status: "Odrzucona", category: "prośba" },
      t9: { status: "Potwierdzona", category: "płatność" },
      t10: { status: "Oczekuje na płatność", category: "płatność w toku" },
      t11: { status: "Przypisz pokój", category: "rezerwacja" },
      t12: { status: "Dostarczenie nieudane", category: "check-in" },
      t13: { status: "Niewysłane", category: "rejestracja podróżnych" },
      t15: { status: "Aktywna", category: "subskrypcja" },
      default: { status: "Komunikat", category: "system" },
    },
    typeLabel: {
      t1: "NOWA REZERWACJA",
      t2: "REZERWACJA ZAKTUALIZOWANA",
      t3: "REZERWACJA ANULOWANA",
      t4: "CHECK-IN",
      t5: "USŁUGA",
      t6: "PROŚBA",
      t7: "PROŚBA ZATWIERDZONA",
      t8: "PROŚBA ODRZUCONA",
      t10: "OCZEKUJE NA PŁATNOŚĆ",
      t11: "PRZYPISZ POKÓJ",
      t12: "DOSTARCZENIE NIEUDANE",
      t13: "REJESTRACJA PODRÓŻNYCH",
      t15: "SUBSKRYPCJA AKTYWNA",
      default: "POWIADOMIENIE",
    },
  },
};
